<div class="ion-padding" style="border-bottom: 1px solid lightgray">
  <ng-container *ngIf="trainingList.length !== 0; else spinner">
    <ion-slides [options]="slideOpts">
      <ion-slide *ngFor="let item of trainingList; index as i">
        <ion-tab-button>
          <ion-avatar>
            <img [src]="item.imgUrl" />
          </ion-avatar>
          <ion-label style="margin: 5px 0 10px 0; font-weight: bold">{{
            item.title
          }}</ion-label>
        </ion-tab-button>
      </ion-slide>
    </ion-slides>
  </ng-container>
  <ng-template #spinner>
    <ion-row>
      <ion-col
        size="12"
        style="display: flex; justify-content: center; align-items: center"
      >
        <ion-spinner></ion-spinner>
      </ion-col>
    </ion-row>
  </ng-template>
</div>
